import { key, notify } from '@databases/ping-registry';
import { createSelectionsPingEffect } from '@databases/selections';
import { getService } from '@databases/service-container';

import { SelectionFeatureKeys, type SelectionEffectFeature } from '../../features/types';

export function createSelectionsPingEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.SELECTIONS_PING_EFFECT,
    type: 'effect',
    // Always active — selection pings are read-only UI notifications
    // that bridge the selections machine to React components via the
    // ping registry. They don't modify data and are needed for all
    // selection modes to keep the UI in sync.
    factory: () => {
      return createSelectionsPingEffect({
        notifyDatabaseSelectionChanged: () => {
          const databaseKey = key('database', {});

          notify(databaseKey, 'selectionChanged', true);
        },
        resolveCellPositionToIds: (position) => {
          const selectionsApi = getService('SelectionsApi');

          return selectionsApi.resolvePositionToIds(position, 'cell');
        },
        notifyCellSelected: (entryId, fieldId, selected) => {
          notify(key('cell', { entryId, fieldId }), 'selected', selected);
        },
      });
    },
  };
}
